<app-nav></app-nav>
<div
  class="page-body-config"
  role="main"
>
  <header>
    <h1 class="page-header">Communication Preferences</h1>
  </header>
  <div class="body-container mx-auto">
    <app-preferences></app-preferences>
  </div>
</div>
<app-footer></app-footer>